export const BuildInfo = {timestamp:1780614320000}
